import { IonButton, IonModal } from "@ionic/react";
import {
  FRAME_ASSEMBLED_BIH_WARNING_HEADER,
  FRAME_ASSEMBLED_BIH_WARNING_MESSAGE,
} from "../../common/constants";

interface Props {
  isOpen: boolean;
  framesAssembled: number;
  priceWarningMessage?: string;
  onDismiss: () => void;
  onRemove: () => void;
  onConvert: () => void;
}

export const FrameAssembledBihWarning: React.FC<Props> = ({
  isOpen,
  framesAssembled,
  priceWarningMessage,
  onDismiss,
  onRemove,
  onConvert,
}) => (
  <IonModal isOpen={isOpen} onDidDismiss={onDismiss} className="cart-modal">
    <div style={{ padding: "24px", textAlign: "center" }}>
      <h2 style={{ margin: "0 0 16px" }}>{FRAME_ASSEMBLED_BIH_WARNING_HEADER}</h2>
      <p style={{ margin: "0 0 16px" }}>{FRAME_ASSEMBLED_BIH_WARNING_MESSAGE}</p>
      {priceWarningMessage && (
        <p style={{ margin: "16px 0", color: "var(--ion-color-danger)", fontWeight: 600, whiteSpace: "pre-line" }}>
          {priceWarningMessage.replace(/\n/g, "\n\n")}
        </p>
      )}
      <IonButton
        expand="block"
        fill="outline"
        color="dark"
        style={{ marginTop: 8, whiteSpace: "normal", height: "auto", padding: "10px 0" }}
        onClick={onRemove}
      >
        {`Izbaci (-${framesAssembled})`}
      </IonButton>
      <IonButton
        expand="block"
        fill="outline"
        color="dark"
        style={{ marginTop: 8, whiteSpace: "normal", height: "auto", padding: "10px 0" }}
        onClick={onConvert}
      >
        {`Rasklopljen ram (+${framesAssembled})`}
      </IonButton>
      <IonButton
        expand="block"
        fill="clear"
        color="medium"
        style={{ marginTop: 8 }}
        onClick={onDismiss}
      >
        Odustani
      </IonButton>
    </div>
  </IonModal>
);
